// W-n in comments are the review-warning ids of the committed plan,
// docs/superpowers/plans/2026-09-19-cubbo-2818-event-close-reconciliation-wms.md.
import { useTranslation } from 'react-i18next'

// Extracted verbatim from the coverage-event detail panel (W-12): the reconciliation tab
// pages its bay rows server-side with exactly the same control, and two copies of the same
// markup drift. Renders nothing for a single page, so callers don't need their own gate.
export const TablePaginator = ({ page, meta, onPage, disabled = false }) => {
  const { i18n } = useTranslation()
  const totalPages = meta?.total_pages ?? 0
  if (totalPages <= 1) return null

  return (
    <div className="flex justify-end gap-2 mt-3 text-sm">
      <button
        aria-label={i18n.t('table_paginator.previous')}
        disabled={disabled || page <= 1}
        onClick={() => onPage(page - 1)}
        className="px-2 py-1 border rounded disabled:opacity-40"
      >
        ‹
      </button>
      <span className="px-2 py-1">
        {meta?.current_page ?? page} / {totalPages}
      </span>
      <button
        aria-label={i18n.t('table_paginator.next')}
        disabled={disabled || page >= totalPages}
        onClick={() => onPage(page + 1)}
        className="px-2 py-1 border rounded disabled:opacity-40"
      >
        ›
      </button>
    </div>
  )
}
